import { useSegmentV1ControllerUpdateStatus } from 'generated/apiComponents';

export const useUpdateSegmentStatusMutation = () => {
  const { mutateAsync, isPending } = useSegmentV1ControllerUpdateStatus();

  return { updateSegmentStatus: mutateAsync, isLoading: isPending };
};
